import React, { ReactNode } from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import usePlatform from "../../../hooks/usePlatform"
import { Locale } from "../../../locale"
import { Grid, Typography } from "@material-ui/core"
import ContentWrapper from "../../../components/Container/ContentWrapper"
import users from "../../../assets/images/icon/users.png"
import board from "../../../assets/images/icon/meeting_board.png"
import comparison from "../../../assets/images/icon/comparison.png"
import SummaryAdvantage from "./summarySection/SummaryAdvantage"
import { FormattedMessage } from "react-intl"
import useScrollImpressionLog from "../../../hooks/useScrollImpressionLog"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: "48px 20px",
      background: "#FAFAFA",
      [theme.breakpoints.up("md")]: {
        padding: "60px 0",
      },
    },
    title: {
      color: "#2684FF",
      fontSize: 20,
      fontWeight: 700,
      marginBottom: 8,
      [theme.breakpoints.up("md")]: {
        fontSize: 28,
        marginBottom: 0,
      },
    },
    advantages: {
      width: 756,
    },
  })
)

export default function Summary() {
  const classes = useStyles()
  const { isDesktop } = usePlatform()
  const { lang } = Locale.getDefault()
  const { ref } = useScrollImpressionLog({
    message: "4_0: 제품과 고객에 대해 다양한 분석을 할 수 있습니다.",
    eventKey: "homepage_data_analytics_detail_section_4_impression",
  })

  return (
    <div className={classes.root} ref={ref}>
      <ContentWrapper>
        <Grid container justify={"space-between"}>
          <TitleByLang lang={lang} isDesktop={isDesktop} />
          <Grid container justify={"space-between"} className={classes.advantages}>
            <SummaryAdvantage
              iconUrl={users}
              title={<FormattedMessage id={"analytics_summary_use_case_title"} />}
              description={<FormattedMessage id={"analytics_summary_use_case_desc"} />}
            />
            <SummaryAdvantage
              iconUrl={comparison}
              title={
                lang === "ko" && isDesktop ? (
                  <>
                    데이터 샘플링 없이
                    <br />
                    정확한 결과
                  </>
                ) : (
                  <FormattedMessage id={"analytics_summary_without_sampling_title"} />
                )
              }
              description={<FormattedMessage id={"analytics_summary_without_sampling_desc"} />}
            />
            <SummaryAdvantage
              iconUrl={board}
              title={
                lang === "ko" && isDesktop ? (
                  <>
                    저장한 차트들을 <br />한 화면에서 한눈에 확인
                  </>
                ) : (
                  <FormattedMessage id={"analytics_summary_save_chart_title"} />
                )
              }
              description={
                lang === "ko" && isDesktop ? (
                  <>
                    자동 업데이트 된 차트를
                    <br />한 화면에서 확인할 수 있습니다.
                  </>
                ) : (
                  <FormattedMessage id={"analytics_summary_save_chart_desc"} />
                )
              }
            />
          </Grid>
        </Grid>
      </ContentWrapper>
    </div>
  )
}

interface LangProps {
  lang: string
  isDesktop: boolean
}

function TitleByLang({ lang, isDesktop }: LangProps) {
  const classes = useStyles()
  if (lang === "ko") {
    return (
      <Typography className={classes.title}>
        제품과 고객에 대해
        <br />
        다양한 분석을{isDesktop && <br />}할 수 있습니다.
      </Typography>
    )
  }

  return (
    <Typography className={classes.title}>
      Break down {isDesktop && <br />}
      your data to find out
      {isDesktop && <br />}
      more about {isDesktop && <br />}
      product and users.
    </Typography>
  )
}
